/// <reference path="jquery-1.3.1-vsdoc.js" />
var DirectoriesUsa;
DirectoriesUsa = {};

// Keep a copy of the last message type
DirectoriesUsa.dataEvent = {};
$(document).bind('originDataEvent', function(evt, type, data) {
	DirectoriesUsa.dataEvent[ type ] = data;
});

DirectoriesUsa.getBrowserClass = function () {

	// logic to determine browser specific CSS class to add to body
	// determine if the browser is Chrome
	var userAgent = navigator.userAgent.toLowerCase();
	$.browser.chrome = /chrome/.test(userAgent);

	// which browser specific CSS class to add
	// Must check for chrome before safari because both flags will be true since both are webkit based
	var cls = $.browser.msie ? 'ie ie' + Math.floor($.browser.version) :
				$.browser.mozilla ? 'ff' :
				$.browser.chrome ? 'chrome' :
				$.browser.safari ? 'safari' :
				'other';

	return cls;
};

DirectoriesUsa.isMacLike = function() {

	return navigator.userAgent.match(/(Mac|iPhone|iPod|iPad)/i);
};

window.getScrollBarWidth = function () {
	var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'),
		widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth(),
		width = 100 - widthWithScroll;

	$outer.remove();

//	if ((DirectoriesUsa.getBrowserClass() == 'chrome') && (DirectoriesUsa.isMacLike())) {

	    if (width <= 0 || width == 100) {
	        return 17;
	    }
	    
//	}
	
	return width;
};

window.scrollbarWidth = window.getScrollBarWidth();

